import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=567c266e&scoped=true&"
import script from "./MenuMobile.vue?vue&type=script&lang=js&"
export * from "./MenuMobile.vue?vue&type=script&lang=js&"
import style0 from "./MenuMobile.vue?vue&type=style&index=0&id=567c266e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c266e",
  null
  
)

export default component.exports